import { chartSwatchContainerWidthPx, chartSwatchRadiusPx, chartSwatchSizePx } from './ChartSwatch';
import {
  buildTooltipOverlaySurfaceSx,
  tooltipOverlayBodyFontWeight,
  tooltipOverlayCompactLineHeight,
  tooltipOverlayFontSize,
  tooltipOverlayLabelFontWeight,
  tooltipOverlayLineHeight,
  tooltipOverlayMetaFontSize,
  tooltipOverlayMetricFontWeight,
  tooltipOverlayPaddingX,
  tooltipOverlayPaddingY,
  tooltipOverlayTextColor,
  tooltipOverlayTitleFontSize,
} from './tooltipOverlayStyles';
import type { SxProps, Theme } from '@mui/material/styles';

export const getChartTooltipSx = (theme: Theme): SxProps<Theme> => ({
  backgroundColor: 'transparent !important',
  border: '0 !important',
  boxShadow: 'none !important',
  padding: '0 !important',
  '&.MuiChartsTooltip-paper, & .MuiChartsTooltip-paper': {
    ...buildTooltipOverlaySurfaceSx(theme),
    maxWidth: 'min(calc(100vw - 32px), 720px)',
    width: 'max-content',
    paddingTop: `${tooltipOverlayPaddingY} !important`,
    paddingBottom: `${tooltipOverlayPaddingY} !important`,
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
  color: tooltipOverlayTextColor,
  fontSize: tooltipOverlayFontSize,
  lineHeight: tooltipOverlayLineHeight,
  fontWeight: tooltipOverlayBodyFontWeight,
  '& .MuiTypography-root, & .MuiChartsTooltip-cell, & .MuiChartsTooltip-labelCell, & .MuiChartsTooltip-valueCell, & .MuiChartsTooltip-axisValueCell, & caption, & td, & th':
    {
      color: tooltipOverlayTextColor,
      fontSize: tooltipOverlayFontSize,
      lineHeight: tooltipOverlayLineHeight,
      fontWeight: tooltipOverlayBodyFontWeight,
    },
  '& .MuiChartsTooltip-table, & table': {
    borderCollapse: 'separate',
    borderSpacing: 0,
    border: '0 !important',
    width: '100% !important',
    tableLayout: 'auto',
  },
  '& .MuiChartsTooltip-table caption, & caption': {
    backgroundImage: `linear-gradient(${theme.app.colors.border}, ${theme.app.colors.border}) !important`,
    backgroundPosition: 'center bottom !important',
    backgroundRepeat: 'no-repeat !important',
    backgroundSize: `calc(100% - (${tooltipOverlayPaddingX} * 2)) 1px !important`,
    borderBottom: '0 !important',
    paddingTop: '0 !important',
    paddingBottom: `${tooltipOverlayPaddingY} !important`,
    paddingLeft: `${tooltipOverlayPaddingX} !important`,
    paddingRight: `${tooltipOverlayPaddingX} !important`,
    textAlign: 'left',
    color: `${tooltipOverlayTextColor} !important`,
    fontSize: `${tooltipOverlayTitleFontSize} !important`,
    fontWeight: `${tooltipOverlayLabelFontWeight} !important`,
    lineHeight: tooltipOverlayCompactLineHeight,
  },
  '& .MuiChartsTooltip-table > tbody > tr > th, & .MuiChartsTooltip-table > tbody > tr > td, & tbody > tr > th, & tbody > tr > td':
    {
      border: '0 !important',
      paddingLeft: `${tooltipOverlayPaddingX} !important`,
      paddingRight: `${tooltipOverlayPaddingX} !important`,
      paddingTop: '4px !important',
      paddingBottom: '4px !important',
      verticalAlign: 'middle !important',
    },
  '& .MuiChartsTooltip-table > tbody > tr:first-of-type > th, & .MuiChartsTooltip-table > tbody > tr:first-of-type > td, & tbody > tr:first-of-type > th, & tbody > tr:first-of-type > td':
    {
      paddingTop: '8px !important',
    },
  '& .MuiChartsTooltip-table > tbody > tr:last-of-type > th, & .MuiChartsTooltip-table > tbody > tr:last-of-type > td, & tbody > tr:last-of-type > th, & tbody > tr:last-of-type > td':
    {
      paddingBottom: '0 !important',
    },
  '& .MuiChartsTooltip-labelCell': {
    color: `${tooltipOverlayTextColor} !important`,
    fontWeight: `${tooltipOverlayBodyFontWeight} !important`,
    textAlign: 'left !important',
  },
  '& .MuiChartsTooltip-valueCell': {
    fontSize: `${tooltipOverlayFontSize} !important`,
    fontWeight: `${tooltipOverlayMetricFontWeight} !important`,
    minWidth: '5ch',
    textAlign: 'right !important',
    whiteSpace: 'nowrap',
    fontVariantNumeric: 'tabular-nums',
  },
  '& .MuiChartsTooltip-axisValueCell': {
    color: `${tooltipOverlayTextColor} !important`,
    fontSize: `${tooltipOverlayMetaFontSize} !important`,
    fontWeight: `${tooltipOverlayBodyFontWeight} !important`,
  },
  '& .MuiChartsTooltip-markContainer': {
    width: `${chartSwatchContainerWidthPx}px !important`,
    display: 'inline-flex !important',
    alignItems: 'center !important',
    justifyContent: 'flex-start !important',
    lineHeight: '0 !important',
    transform: 'translateY(-1px)',
    verticalAlign: 'middle !important',
  },
  '& .MuiChartsTooltip-mark': {
    display: 'inline-flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    width: `${chartSwatchSizePx}px !important`,
    height: `${chartSwatchSizePx}px !important`,
    borderRadius: `${chartSwatchRadiusPx}px !important`,
    marginTop: '0 !important',
    marginBottom: '0 !important',
  },
});
